import Swiper from 'swiper';
import { Pagination, Autoplay } from 'swiper/modules';

/**
 * Initialise the image slider for every .block-half-text-media on the page.
 * Each instance binds pagination to its own element so multiple blocks
 * on one page don't clash.
 */
function initHalfTextMediaSliders() {
    const blocks = document.querySelectorAll('.block-half-text-media');

    blocks.forEach((block) => {
        const swiperEl = block.querySelector('.swiper');
        if (!swiperEl || swiperEl.swiper) return; // skip if missing or already initialised

        const slides = swiperEl.querySelectorAll('.swiper-slide');
        const multiple = slides.length > 1;

        new Swiper(swiperEl, {
            modules: [Pagination, Autoplay],
            slidesPerView: 1,
            spaceBetween: 0,
            loop: multiple,
            speed: 600,
            autoplay: multiple
                ? { delay: 5000, disableOnInteraction: false }
                : false,
            pagination: {
                el: swiperEl.querySelector('.swiper-pagination'),
                clickable: true,
            },
        });
    });
}

if (document.readyState !== 'loading') {
    initHalfTextMediaSliders();
} else {
    document.addEventListener('DOMContentLoaded', initHalfTextMediaSliders);
}
